// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"f5ce7a94","256":"737c8b31","484":"14cb0921","551":"c2ddb01f","617":"c2cb4bc1","819":"ec15532e","821":"7b3b2b1a","842":"01821987"}[chunkId] + ".chunk.js";
};